var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferAndEarn2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "59px",
    viewBox: "0 0 59 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4216BD9F-F19A-4109-9E7B-E68DADEF2AD5@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 29.5,
    cy: 29.5,
    r: 29.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.5934889%",
    y1: "28.359375%",
    x2: "133.857016%",
    y2: "188.554688%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79E88",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999A9B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-Settings",
    transform: "translate(-1066.000000, -644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1066.000000, 644.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2409853,26.5075103 L41.3388466,21.3066479 L66.9329416,7.9514804 L72.5124021,20.3675398 L65.5388665,24.1385792 C52.3665046,31.2617228 38.2476494,36.474445 23.6067625,39.6200332 L23.6067625,39.6200332 L23.6067625,39.6200332 L21.2409853,26.5075103 Z",
    id: "Path-9",
    fill: "#CCCCCC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3296957,19.3324144 C14.502891,12.7527061 13.4212369,8.7980046 13.0847334,7.46830989 C12.5799781,5.47376784 13.8703401,4.1466794 15.6239052,4.81022362 C17.5348607,2.62487314 25.01068,-0.876739772 28.0716465,0.201200067 C31.1326131,1.27913991 32.1727647,6.08273093 28.6532287,8.35378733 C26.3068713,9.86782493 22.199027,13.5273673 16.3296957,19.3324144 Z",
    id: "Path-2",
    fill: "#333333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4138493,6.87680204 L29.1707154,15.0874305 C29.4526948,18.1463975 27.2284069,20.8658658 24.1742823,21.1961906 L24.1742823,21.1961906 L24.1742823,21.1961906 L24.3505074,26.5075103 L14.5010891,22.3136254 L16.5078387,19.1087553 C17.1397751,18.0995241 17.4226402,16.910629 17.3129244,15.724942 L17.3129244,15.724942 L17.3129244,15.724942 L16.1713586,16.3265612 C15.4039946,16.7309715 14.4633263,16.5938395 13.8433572,15.9871818 C13.2392987,15.3960932 13.1391787,14.45969 13.6046128,13.7542515 L13.6520564,13.6823432 C14.1347352,12.9507677 15.091759,12.7015164 15.8699788,13.1046982 L17.0506997,13.7164086 L17.0506997,13.7164086 C17.6162767,11.9364908 18.9603923,10.5102403 20.7036771,9.84020842 L28.4138493,6.87680204 L28.4138493,6.87680204 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20.378402, 8.288103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 7.45627377,
    cy: 3.0418396,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#18233D",
    cx: 2.52250731,
    cy: 4.03448627,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32572363,3.78699324 C5.46159874,3.69974246 5.64205808,3.73981814 5.72879084,3.87650477 L6.01323393,4.32920701 C6.53298165,5.16660767 6.76139428,5.60490591 6.76139428,5.8046706 C6.76139428,6.1997921 6.4122926,6.31339662 5.80850001,6.31339662 C5.64730255,6.31339662 5.5166262,6.1819398 5.5166262,6.0197796 C5.5166262,5.8576194 5.64730255,5.72616258 5.80850001,5.72616258 C5.91543979,5.72616258 6.00555386,5.72154322 6.07747087,5.71322634 L6.13575728,5.70460225 L6.10087363,5.63635355 C5.99086656,5.42795665 5.76595869,5.04026623 5.44770518,4.5282879 L5.23674353,4.19246777 C5.15001076,4.05578114 5.18984851,3.87424401 5.32572363,3.78699324 Z",
    id: "Path-16",
    fill: "#18233D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99777457,8.00507293 L3.5092606,8.00507293 C3.89226149,8.72382819 4.38090467,9.08320581 4.97519014,9.08320581 C5.56947562,9.08320581 5.9103371,8.72382819 5.99777457,8.00507293 Z",
    id: "Path-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01588396,1.11244407 C3.25768014,1.11244407 3.45369467,1.3096293 3.45369467,1.5528696 C3.45369467,1.79610991 3.25768014,1.99329513 3.01588396,1.99329513 C2.40410735,1.99329513 1.8642038,2.26485919 1.373029,2.83419308 C1.21454375,3.01789759 0.938028295,3.03757451 0.755414447,2.8781427 C0.572800599,2.7187109 0.553240506,2.44054396 0.711725757,2.25683945 C1.36238362,1.50264445 2.13815113,1.11244407 3.01588396,1.11244407 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(2.029127, 2.049196) rotate(22.000000) translate(-2.029127, -2.049196) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08580053,0.479210685 C8.32759671,0.479210685 8.52361124,0.676395912 8.52361124,0.919636216 C8.52361124,1.16287652 8.32759671,1.36006175 8.08580053,1.36006175 C7.51307317,1.36006175 7.16015755,1.51304927 6.96946942,1.80785191 L6.94332563,1.85093009 C6.82323087,2.06204689 6.55574695,2.13525338 6.34588356,2.01444136 C6.13602017,1.89362935 6.06324831,1.62454788 6.18334306,1.41343108 C6.54006918,0.786335596 7.19629118,0.479210685 8.08580053,0.479210685 Z",
    id: "Path-5",
    fill: "#18233D",
    fillRule: "nonzero",
    transform: "translate(7.324530, 1.275946) rotate(18.000000) translate(-7.324530, -1.275946) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4853053,14.4634226 C14.535621,14.3171877 14.6832088,14.2359523 14.8255895,14.270097 L14.8583075,14.2800477 L15.9232959,14.6743472 C16.0751131,14.7305558 16.1542588,14.9037876 16.1000727,15.0612713 C16.049757,15.2075062 15.9021692,15.2887416 15.7597885,15.2545969 L15.7270705,15.2446462 L14.6620822,14.8503467 C14.5102649,14.7941381 14.4311192,14.6209063 14.4853053,14.4634226 Z",
    id: "Path-18",
    fill: "#18233D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5010891,22.3136254 C12.4844133,22.5257423 10.9732871,24.2744109 9.96771048,27.5596313 C8.96213383,30.8448517 5.63956367,43.6567898 2.07388814e-15,65.9954458 L24.4294188,67.4512018 L26.6190923,42.101989 C28.4650228,38.0722457 29.0309476,34.5447797 28.3168667,31.5195911 C27.6027859,28.4944024 24.5785172,26.0906828 19.2440608,24.3084323 L14.5010891,22.3136254 Z",
    id: "Path-3",
    fill: "#CCCCCC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0353447,43.276457 L23.8456712,68.6256699 C17.0053076,68.2180507 11.7032855,62.4888041 11.8259277,55.6374037 L12.2192762,33.6630235 L12.2192762,33.6630235 L26.0353447,43.276457 Z",
    id: "Path",
    fill: "#0D152A",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1807505,35.2123997 L13.4002196,48.5112847 C14.3603693,58.982168 23.6270524,66.692141 34.0979357,65.7319914 C34.5612214,65.6895095 35.0227943,65.6300606 35.4817248,65.5537645 L54.0880162,62.4605131 L54.0880162,62.4605131 L50.1748406,48.6571721 L27.5959007,51.8644573 L26.2282477,33.5451102 C25.9473833,29.7830061 22.6699097,26.9609038 18.9078056,27.2417682 C18.8094349,27.2491122 18.7112349,27.2585862 18.6132745,27.2701835 C14.6710577,27.736894 11.818257,31.2592377 12.1807505,35.2123997 Z",
    id: "Path-4",
    fill: "#CCCCCC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1742823,21.1961906 C21.7166065,21.2866899 20.2803405,20.5586423 19.8654843,19.0120478 C20.3914001,21.8663652 21.8546527,23.3960986 24.255242,23.6012479 L24.1742823,21.1961906 Z",
    id: "Path-10",
    fill: "#0D152A",
    fillRule: "evenodd"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferAndEarn2);
export default __webpack_public_path__ + "static/media/refer_and_earn_2.f9c58dca2162bd650a04faada3e50b9b.svg";
export { ForwardRef as ReactComponent };